<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.7587 9.72494L8.86974 0L1.86429 9.54696C0.696502 10.9611 0 12.7443 0 14.6824C0 19.2761 3.91303 23 8.74 23C13.567 23 17.48 19.2761 17.48 14.6824C17.48 12.8247 16.8401 11.1094 15.7587 9.72494ZM2.81006 11.3334C3.27903 10.3825 5.06607 7.99357 8.17116 4.1665C8.17116 4.64603 7.98324 5.24104 7.60738 5.95154C7.32779 6.48008 6.98365 6.95685 6.54412 7.56577C6.09736 8.1847 5.55206 8.94016 4.87583 10.0253C4.64228 10.4 4.43437 10.7162 4.25025 10.9962C3.37672 12.3244 3.03859 12.8385 3.03859 14.9356C3.03859 16.6283 4.09329 18.2997 6.2027 19.9498C4.79801 19.5874 3.00455 18.1488 2.28032 16.1105C1.55609 14.0723 2.1066 12.7597 2.81006 11.3334Z"
                :fill="color" 
            />
            </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgILMANewsFeed',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>